const brandsSearch = document.getElementById('brands_search');
const letterItems = document.querySelectorAll('#letters .letter');

// remove brandChars with no brands
document.querySelectorAll('.char-item:not(:has(li))').forEach(charItem => charItem.remove())

letterItems.forEach(letterItem => {
  const letter = letterItem.innerText;
  const letterBrandsGroup = document.getElementById(letter);

  // add smooth scroll event to on a letter click or keyboard activation
  letterItem.addEventListener('click', () => scrollSmoothlyTo(letterBrandsGroup));
  letterItem.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      scrollSmoothlyTo(letterBrandsGroup);
    }
  });

  if (!letterBrandsGroup) letterItem.classList.add('disabled');
})

brandsSearch.addEventListener('keyup', (event) => {
  const brandCharListsContainer = document.querySelector('.brands_list-wrapper');
  const brandItems = brandCharListsContainer.getElementsByTagName('li');
  const searchInputValue = event.target.value.toUpperCase();

  // manage brand visibility
  for (const brandItem of brandItems) {
    const brandName = brandItem.innerText.toUpperCase()

    if (brandName.includes(searchInputValue)) {
      brandItem.classList.remove('d-none');
      brandItem.classList.add('visible');
    } else {
      brandItem.classList.add('d-none');
      brandItem.classList.remove('visible');
    }
  }
});

function scrollSmoothlyTo(target) {
  if (!target) return;

  window.scrollTo({
    top: target.offsetTop - document.querySelector('page-header').offsetHeight,
    behavior: 'smooth',
  });
}